<template>
  <div class="center">
    <div class="bg-white rounded center p4 inline-block mt2">
      <div class="fz32 light mt2">Takk for besillingen!</div>
      <div class="fz16 pt3 pb2">
        Din bestilling har blitt mottatt og vil bli behandlet så raskt som mulig.
      </div>
      <md-button class="md-raised md-primary px3 py1" @click.native="viewOrder()">Se din ordre her</md-button>
    </div>
  </div>
</template>

<script>
  import Cookies from 'js-cookie';

  export default {
    mounted() {
      Cookies.remove('cart');
      this.$root.$data.cart = null;
    },

    methods: {
      viewOrder() {
        this.$router.push({ name: 'view-order', params: { orderId: this.$route.params.orderId } });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// OrderComplete.vue?5f1bf284